<template>
  <v-card>
    <Loader v-if="!record" loading />

    <v-container v-else>
      <div class="mb-5">
        <v-row>
          <v-col lg="6">
            <div class="mb-1"><span class="font-weight-bold">Ресурс:</span> {{ record.unit.name }}</div>

            <div class="mb-1"><span class="font-weight-bold">Место приёма:&nbsp;</span>{{ workplace }}</div>

            <v-row>
              <v-col lg="4">
                <div><span class="font-weight-bold">Дата приема:</span><br />{{ date }}</div>
              </v-col>
              <v-col lg="4">
                <div><span class="font-weight-bold">Время приёма:</span><br />{{ time }}</div>
              </v-col>
              <v-col lg="4">
                <div><span class="font-weight-bold">Продолжительность:</span><br />15 минут</div>
              </v-col>
            </v-row>
          </v-col>

          <v-col lg="6">
            <v-checkbox readonly :label="`CITO`" :value="record.is_cito"></v-checkbox>
            <div class="mb-1">
              <span class="font-weight-bold">Пациент:</span> {{ patientName
              }}<span v-if="patientYears">,&nbsp;{{ patientYears }} лет</span>
            </div>
          </v-col>
        </v-row>
      </div>

      <h2>Назначенные услуги</h2>
      <div class="v-data-table v-data-table--has-top v-data-table--has-bottom theme--light mb-2">
        <div class="v-data-table__wrapper overflow-auto">
          <table class="table">
            <thead class="v-data-table-header">
              <tr>
                <th scope="col">Код услуги</th>
                <th scope="col">Наименование услуги</th>
                <th scope="col">Количество</th>
                <th scope="col">Направление</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(service, idx) in record.services" :key="`service-${idx}-${service.id}`">
                <td>{{ service.service.code }}</td>
                <td>{{ service.service.name }}</td>
                <td>1</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <v-row>
        <v-col>
          <div class="text-secondary">Записал: {{ createAt }} Подоляко Лариса Алексеевна</div>
        </v-col>
        <v-col>
          <div class="d-flex w-100">
            <div class="ml-auto phone-padding">
              <span class="material-icons">
                phone
              </span>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { IclService } from "@/services/api/icl.service.js";
import Loader from "@/components/Loader.vue";

export default {
  name: "ShowTask",
  components: { Loader },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      record: null,
    };
  },

  computed: {
    patientName() {
      return `${this.record.patient.last_name} ${this.record.patient.first_name} ${this.record.patient.middle_name}`;
    },

    patientYears() {
      if (this.record.patient.birthday) {
        return this.$date().diff(this.$date(this.record.patient.birthday), "year");
      }

      return "";
    },

    workplace() {
      return this.record.unit.workplace.name;
    },

    date() {
      return this.$date(this.record.start_at).format("DD.MM.YYYY");
    },

    time() {
      return this.$date(this.record.start_at).format("HH:mm");
    },

    createAt() {
      return this.$date(this.record.created_at).format("DD.MM.YYYY HH:mm:ss");
    },
  },

  async created() {
    this.record = await IclService.getTimetableRecord(this.item.id);
    console.log("record", this.record);
  },

  methods: {},
};
</script>

<style scoped></style>
